<style scoped>
    .topBox {
        width: 7.5rem;
        height: .86rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        font-size: .28rem;
        font-weight: 500;
    }

    .topBox span.active {
        font-weight: bold;
        color: #408BFB;
        position: relative;
    }

    .topBox span.active::after {
        content: "";
        width: 100%;
        border-radius: .3rem;
        height: .06rem;
        background: #408BFB;
        position: absolute;
        bottom: -.14rem;
        left: 0;
    }

    .line {
        /*width: .02rem;*/
        /*height: .54rem;*/
        /*background: #BFBFBF;*/
        margin: 0 1.48rem;
    }

    .scaleList {
        padding: .38rem;
    }

    .scaleList li {
        padding: .32rem;
        background: #fff;
        display: flex;
        justify-content: space-between;

        border: .01rem solid rgba(230, 230, 230, 0.4);
        box-shadow: 0 .16rem .32rem 0 rgba(31, 33, 51, 0.05);
        border-radius: .08rem;
        margin-bottom: .38rem;
    }

    .scaleLeft {
        width: 5rem;
    }

    .scaleTitle {
        font-size: .32rem;
        color: #000;
        margin-bottom: .2rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        line-height: .4rem;
    }

    .scaleContent {
        font-size: .24rem;
        font-weight: 500;
        color: #484848;
        line-height: .32rem;

        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    .scaleBottom {
        display: flex;
        justify-content: space-between;
        margin-top: .2rem;
        font-size: .22rem;
        color: #747474;
    }

    .price {
        font-size: .3rem;
        font-weight: bold;
        color: #F31616;
    }

    .scaleBottom span {
        font-size: .24rem;
        font-weight: bold;
        color: #9E9E9E;

    }

    .scaleRight {
        width: 1.2rem;
        height: 1.2rem;
        border-radius: .08rem;
        /*background: url("~assets/tuijian.png") no-repeat center/cover;*/
        position: relative;
        margin-right: .32rem;
    }

    .scaleRight .labelName {
        position: absolute;
        top: 0;
        right: 8px;
        padding: .06rem .1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        font-size: .18rem;
        font-weight: bold;
        color: #00C59F;
        border-radius: 0 0 .08rem .08rem;
    }

    .emptyBox{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .emptyImg{
        width: 3.98rem;
        height: 3.28rem;
        background: url("~assets/test.png") no-repeat center/cover;
        margin-top: 1.5rem;
        margin-bottom: .92rem;
        font-size: .3rem;
        color: #6F6F6F;
    }
    .emptyBtn{
        margin-bottom: .28rem;
        width: 2.4rem;
        height: .72rem;
        border-radius: .1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .3rem;
        color: #fff;
        background: #408BFB;
    }
</style>
<template>
    <div style="padding-top: 1rem">
        <topbar text="我的测评"></topbar>
        <div class="topBox">
            <span :class="{active:testStatus==0}" @click="getList(0)">未完成</span>
            <div class="line"></div>
            <span :class="{active:testStatus==1}" @click="getList(1)">已完成</span>
        </div>
        <ul class="scaleList" v-if="!emptyStatus">
            <li v-for="(item,index) in scaleUserTestList"
                @click="selectScale(item.scaleInfo.scaleId,item.scaleUserTest.testId)">

                <div class="scaleRight"
                     :style="{background: `url(${EnvUrl}${item.scaleInfo.pic}) no-repeat center/cover`}">
                    <div class="labelName">{{item.scaleInfo.labelName}}</div>
                </div>
                <div class="scaleLeft">
                    <div class="scaleTitle">{{item.scaleInfo.title}}</div>
                    <div class="scaleContent">{{item.scaleInfo.tagline}}</div>
                    <div class="scaleBottom">
                        {{item.scaleUserTest.createTime | time}}  <span style="color: red">{{item.scaleUserTest.payStatus | isPayStatus}}</span>
                    </div>
                </div>
            </li>
            <no-more-data :noMoreData="noMoreData"></no-more-data>
        </ul>

        <div class="emptyBox" v-if="emptyStatus">
            <div class="emptyImg"></div>
            <div class="emptyBtn" @click="to()">开启测评</div>
            <div class="emptyName">快来测试吧~</div>
        </div>


    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                slidesReal: [],
                scaleLabelList: [],
                scaleUserTestList: [],
                indexNum: -1,
                labelId: '',
                pageIndex: 1,
                pageSize: 10,
                noMoreData: false,
                isLoading: false,
                emptyStatus: false,
                count: 0,
                testStatus: 0,
                userId: '',
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
            isPayStatus(value){
                return ['','已支付'][value]
            }
        },
        computed: {},
        methods: {
            selectScale(id, testId) {
                if(this.testStatus){
                    this.$router.push(`/result?testId=${testId}`)
                }else{
                    this.$router.push(`/testDetail?scaleId=${id}&testId=${testId}`)
                }
            },
            to() {
                this.$router.push(`/`)
            },
            getList(index) {
                this.testStatus = index;
                this.pageIndex = 1;
                this.scaleUserTestList = [];
                this.noMoreData = false;
                this.isLoading = false;
                this.emptyStatus = false;
                this.getScaleUserTestList()
            },
            handleScroll() {

                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {

                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.getScaleUserTestList()
                    }
                }
            },
            async getScaleUserTestList() {
                let obj = {}
                obj.pageIndex = this.pageIndex;
                obj.pageSize = this.pageSize;
                obj.userId = this.userId;
                obj.testStatus = this.testStatus;
                let data = await getSources("/bear-scale/api/scaleUser/getScaleUserTestList.json", obj);
                if (data.status === 0) {
                    this.isLoading = false;
                    this.count = data.count;
                    this.scaleUserTestList = [...this.scaleUserTestList, ...data.scaleUserTestList];
                    if (data.scaleUserTestList.length == 0) {
                        this.emptyStatus = true
                    } else {
                        console.log(111111)
                        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                            console.log('显示')
                            this.noMoreData = true
                        } else {
                            console.log(2)
                            this.noMoreData = false
                        }
                    }

                }else{
                    alert(data.msg)
                }
            },
        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            this.userId = localStorage.getItem('userId');
            if (!localStorage.getItem('userId') && this.$route.path !== '/login') {
                if (this.$route.query.code) {
                    this.$router.push(`/welcome?next=${encodeURIComponent(this.$route.fullPath)}&code=${this.$route.query.code}`)
                } else {
                    this.$router.push(`/welcome?next=${encodeURIComponent(this.$route.fullPath)}`)
                }
            }
//            if (this.$route.query.testStatus == 0 || this.$route.query.testStatus == 1) {
//                this.testStatus = this.$route.query.testStatus
//            }
            this.getScaleUserTestList();
            window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/myTest.vue?499ebfd9